import { render, staticRenderFns } from "./TestVideoRecordPageView.vue?vue&type=template&id=4c6a5666&scoped=true&"
import script from "./TestVideoRecordPageView.vue?vue&type=script&lang=js&"
export * from "./TestVideoRecordPageView.vue?vue&type=script&lang=js&"
import style0 from "./TestVideoRecordPageView.vue?vue&type=style&index=0&id=4c6a5666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6a5666",
  null
  
)

export default component.exports